// Where a campaign's uploaded images live (issue 1566), with no other
// imports: the sanitiser and `uploads.js` both read it, so the one rule of
// what an <img> may point at is written once.
export const UPLOAD_PATH_RE = /^\/uploads\/[0-9a-f-]{36}\/[0-9a-f-]{36}-(display|thumb)\.webp$/i;

const API_BASE = process.env.REACT_APP_API_URL || '';

const originOf = (address) => {
  try { return new URL(address).origin; } catch (e) { return null; }
};

/**
 * Whether `src` is one of our stored images: an `/uploads/<campaign>/<id>-…webp`
 * path on this page's origin or the API's, with no query or fragment. Anything
 * else (another host, a data: URI, a hot-linked picture) is not.
 */
export function isUploadAddress(src) {
  if (typeof src !== 'string' || !src) return false;
  let url;
  try { url = new URL(src, window.location.href); } catch (e) { return false; }
  if (url.search || url.hash || !UPLOAD_PATH_RE.test(url.pathname)) return false;
  const allowed = [window.location.origin, API_BASE ? originOf(API_BASE) : null].filter(Boolean);
  return allowed.includes(url.origin);
}
